export class Dealer {
    
    dealerCode: string; 
    divisionCode: string;
    geoSalesCode: string;
    pandAC: string;
    dealerSubCode: string;
    oldRegionCode: string;
    legalName: string;
    dealerEmail : string;
    dealerPAndAC: string;
    dealerName: string;
    dealerPhone : string;    
    nationalId : string;
    physicalStreet: string;
    physicalCity: string;
    physicalState: string;
    physicalZipCode: string;   

	constructor() {
	
	}
}